{
  "lib_calendar": {
    "appointment-cancellation-dialog": {
      "buttons": {
        "back": "Zpět",
        "cancel": "Zrušit schůzku",
        "close": "Zavřít",
        "next": "Další"
      },
      "text": {
        "title": "Zrušení schůzky",
        "description": "Můžete nám říct více, proč už nemůžete dodržet schůzku?",
        "appointment-cancelled-successfully": "Schůzka byla úspěšně zrušena!",
        "block_customer": "Chcete tohoto zákazníka zablokovat?",
        "message_to_customer": "Zpráva pro zákazníka",
        "no": "NE",
        "no_show": "Zákazník se neobjevil",
        "not_show_up": "Tento zákazník se již nedostavil na {{ celkem }} schůzku(y) v minulosti.",
        "not_show_up_first_time": "Je to poprvé, co se tento zákazník nedostavil.",
        "reason": "Váš důvod",
        "reason-better-deal": "Našel jsem lepší nabídku",
        "reason-mistake": "Rozmyslel jsem si to nebo jsem omylem provedl rezervaci",
        "reason-other": "Jiný důvod",
        "reason-salon-asked-to-cancel": "V salonu se mě zeptali, zda mohu schůzku zrušit",
        "reason-unforeseen-circumstance": "Kvůli nepředvídaným okolnostem jsem nemohl dodržet schůzku",
        "yes": "ANO"
      }
    },
    "appointment-chat-box": {
      "text": {
        "chat-with": "Chat s {{name}}",
        "customer": "zákazník",
        "message": "Vaše zpráva",
        "salon": "salon"
      }
    },
    "appointment-confirmation-dialog": {
      "buttons": {
        "cancel": "Zrušit",
        "confirm-and-book": "Potvrzení a rezervace",
        "confirm-and-update": "Potvrzení a aktualizace"
      },
      "text": {
        "title": "Potvrzení jmenování",
        "book-successfully": "Vaše schůzka byla úspěšně rezervována",
        "update-successfully": "Vaše schůzka byla úspěšně aktualizována"
      }
    },
    "appointment-details": {
      "text": {
        "serve-by-staff": "Sloužit podle {{staff}}",
        "staff_selected_by_customer": "Zaměstnance vybírá zákazník",
        "total": "Celkem"
      }
    },
    "appointment-details-card": {
      "buttons": {
        "checkin": "CHECK IN"
      },
      "text": {
        "appointment-canceled-by-salon": "Schůzka byla salónem zrušena",
        "appointment-canceled-by-you": "Schůzka byla zrušena z vaší strany",
        "status": "Stav"
      }
    },
    "appointment-details-dialog": {
      "buttons": {
        "back": "Zpět",
        "edit": "Úprava schůzky"
      },
      "text": {
        "appointment_history": "Historie jmenování",
        "edit_profile": "Upravit profil",
        "more_about_customer": "Více o tomto zákazníkovi",
        "Visit history": "Navštivte historii"
      }
    },
    "appointment-details-page": {
      "buttons": {
        "cancel": "Zrušit schůzku"
      },
      "text": {
        "creation_time": "Doba vytvoření",
        "last_update": "Poslední aktualizace"
      }
    },
    "appointment-form": {
      "text": {
        "customer-selection": "Výběr zákazníků",
        "note": "Poznámka",
        "rwg_appointment_hint": "Služba schůzek Google není upravitelná",
        "service-selection": "Výběr služby",
        "staff-cannot-serve-any-hint": "Vybraní zaměstnanci nemohou sloužit žádnou vybranou službu. Zvažte prosím výběr jiného zaměstnance!",
        "staff-cannot-serve-all-hint": "Vybraní zaměstnanci nemohou poskytovat všechny vybrané služby. Některé z nich bude obsluhovat jiný pracovník!",
        "staff_selected_by_customer": "Zaměstnance vybírá zákazník",
        "staff-selection": "Výběr zaměstnanců"
      }
    },
    "appointment-form-dialog": {
      "text": {
        "create_new_appointment": "Rezervovat novou schůzku",
        "edit_appointment": "Změna schůzky"
      },
      "buttons": {
        "book": "BOOK",
        "close": "Zpět",
        "save": "Uložit"
      }
    },
    "appointment-history-dialog": {
      "text": {
        "appointment_history": "Aktuálně zobrazené termíny",
        "empty_history": "Historie zobrazení schůzek je prázdná",
        "last_seen": "Naposledy viděno"
      }
    },
    "appointment-table": {
      "buttons": {
        "view": "Přehrát"
      },
      "text": {
        "all": "Všechny",
        "customer": "Zákazník",
        "date": "Datum",
        "service": "Služba",
        "staff": "Zaměstnanci",
        "status": "Status"
      }
    },
    "available-date-selection-by-month": {
      "text": {
        "not-available": "Není k dispozici. Vyberte prosím jiný měsíc!"
      }
    },
    "available-date-selection-by-serie": {
      "text": {
        "date_range": "Období",
        "end_time": "Čas ukončení",
        "from_date": "Datum zahájení",
        "start_time": "Čas zahájení",
        "to_date": "Datum ukončení",
        "repeated_week_day": "Opakování ve všední dny",
        "repeated_week_day_required": "Vyberte prosím alespoň jeden den v týdnu"
      }
    },
    "available-date-selection-form": {
      "text": {
        "date_selection": "Výběr data",
        "repeat_settings": "Nastavení opakování",
        "unable_to_block": "Nic není blokováno, protože salon je zavřený nebo jsou ve vybraných dnech již jiné termíny/blokády"
      }
    },
    "available-slot-selection-by-date": {
      "text": {
        "afternoon": "ODPOLEDNE",
        "evening": "VEČER",
        "morning": "RÁNO",
        "not-available": "Není k dispozici. Vyberte si prosím jiný termín!"
      }
    },
    "available-slot-selection-by-week": {
      "text": {
        "not-available": "Není k dispozici. Vyberte si prosím jiný týden!"
      }
    },
    "available-slot-selection-form": {
      "buttons": {
        "date-view": "Zobrazení data",
        "week-view": "Týdenní pohled"
      },
      "text": {
        "date-time-selection": "Výběr data a času",
        "date-time-selection-hint": "Vyberte prosím alespoň jednu službu",
        "slot_tact": "Časový interval rezervace",
        "slot_tact_example": {
          "5": "Např. 09:00, 09:05, 09:10, 09:15, 09:20, atd.",
          "15": "Např. 09:00, 09:15, 09:30, 09:45, 10:00, atd.",
          "30": "Např. 09:00, 09:30, 10:00, 10:30, 11:00, atd.",
          "60": "Např. 09:00, 10:00, 11:00, 12:00, 13:00, atd."
        }
      }
    },
    "blocker-deletion-dialog": {
      "buttons": {
        "delete": "Odstranit"
      },
      "text": {
        "title": "Odstranění blokátoru",
        "delete_confirmation": "Určitě chcete tento blokátor odstranit? Tuto akci nelze vrátit zpět.",
        "delete_single_blocker_in_series": "Odstranit pouze tento blokátor",
        "delete_series_blocker": "Odstranění všech blokátorů v této sérii",
        "delete_successfully": "Úspěšně odstraněno"
      }
    },
    "blocker-details-card": {
      "text": {
        "belong_to_series_blocker": "Tento blokátor je prvkem blokátoru série"
      }
    },
    "blocker-details-dialog": {
      "text": {
        "creation_time": "Doba vytvoření",
        "last_update": "Poslední aktualizace"
      },
      "buttons": {
        "back": "Zpět",
        "edit": "Blokování úprav",
        "delete": "Odstranit blokátor"
      }
    },
    "blocker-form": {
      "text": {
        "all_day": "Blok na celý den",
        "duration": "Doba trvání",
        "off": "OFF",
        "on": "ON",
        "reason": "Popis",
        "reason_placeholder": "např. důvod blokování",
        "series_blocker": "Blokátor série",
        "staff-selection": "Výběr zaměstnanců"
      }
    },
    "blocker-form-dialog": {
      "text": {
        "blocker_updated": "Blokátor je úspěšně aktualizován",
        "create_new_blocker": "Vytvoření nového blokátoru",
        "edit_blocker": "Blokátor změn",
        "new_blocker_created": "Nový blokátor je úspěšně vytvořen",
        "new_serie_blocker_created": "Nová řada blokátorů je úspěšně vytvořena"
      },
      "buttons": {
        "close": "Zpět",
        "create": "Vytvořit",
        "save": "Uložit"
      }
    },
    "business-notification-dialog": {
      "buttons": {
        "close": "Zpět"
      },
      "text": {
        "no_notification": "Žádná oznámení od posledních {{ day }} dnů",
        "notification": "Oznámení",
        "staff": "Zaměstnanci"
      }
    },
    "date-picker": {
      "current": {
        "agenda": "Tento týden",
        "day": "Dnes",
        "month": "Tento měsíc",
        "week": "Tento týden"
      }
    },
    "floating-buttons": {
      "buttons": {
        "new_appointment": "Nové jmenování",
        "new_blocker": "Nový blokátor"
      }
    },
    "quick-update-appointment-dialog": {
      "buttons": {
        "cancel": "Zrušit",
        "confirm": "Potvrďte"
      },
      "text": {
        "original_appointment": "Původní jmenování",
        "original_blocker": "Původní blokátor",
        "staff": "Zaměstnanci",
        "start_time": "Datum a čas",
        "update_unavailable": "Požadovaný časový interval není k dispozici!",
        "updated_confirmation": "Potvrzení aktualizace",
        "updated_successfully": "Úspěšně aktualizováno!"
      }
    },
    "tool_bar": {
      "buttons": {
        "more": "Více na",
        "view_appointment_history": "Aktuálně zobrazené termíny",
        "view_cancelled_appointment": "Zobrazit zrušené termíny"
      },
      "view_mode": {
        "agenda": "Zobrazení agendy",
        "day": "Denní pohled",
        "month": "Měsíční zobrazení",
        "week": "Týdenní pohled"
      }
    }
  }
}
